import React, { Component } from "react";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import { Div, Text, Row, Col, Image } from "atomize";
import SolutionsDashboard from "../common/SolutionsDashboard";
import ImageLink from "../common/ImageLink";
import BrandImages from "../common/BrandImages";

export default class InfluencerDashboard extends Component {
  render() {
    const { content } = this.props;
    return (
      <Div m={{ t: "12.8rem" }}>
        <SolutionsDashboard content={content} />
        <WebsiteContainer>
          <CustomContainer>
              <BrandImages content={content} />
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    );
  }
}
